import styled from 'styled-components';

const FooterContainer = styled.footer`
  width: 100%;
  background-color: ${props => props.theme.colors.wood};
  color: ${props => props.theme.colors.cream};
  padding: 2rem;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 0 2rem;
`;

const FooterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
`;

const Copyright = styled.p`
  font-family: ${props => props.theme.fonts.body};
  font-size: 0.9rem;
  margin: 0;
`;

const Designer = styled.p`
  font-family: ${props => props.theme.fonts.body};
  font-size: 0.8rem;
  color: ${props => props.theme.colors.cream};
  opacity: 0.9;
  margin: 0;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1.5rem;
`;

const SocialLink = styled.a`
  color: ${props => props.theme.colors.cream};
  font-size: 1.5rem;
  transition: all 0.3s ease;

  &:hover {
    color: ${props => props.theme.colors.brick};
    transform: translateY(-2px);
  }
`;

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <FooterRow>
          <Copyright>
            {currentYear} Anna Sanz. Tous droits réservés.
          </Copyright>
          <SocialLinks>

            <SocialLink 
              href="https://facebook.com/annasanz34" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook"></i>
            </SocialLink>
          </SocialLinks>
        </FooterRow>
        <Designer>
          Site conçu par <a href="https://sanzcloud.com" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'underline'}}> SANZ CLOUD.</a>
        </Designer>
      </FooterContent>
    </FooterContainer>
  );
}

export default Footer;
